import React from "react";
import BasicTabs from "../../../../../Tabs/TabsMain";
import { Box } from "@mui/material";
import OnlineTabItemEdit from "./OnlineTabItemEdit";

function OnlineTabEdit({ selectedTab }) {
  return (
    <Box
      sx={{
        mt: "-30px",
        ml: "-10px",
        mr: "-10px",
      }}
    >
      <BasicTabs
        // selected={true}
        tab1Name={selectedTab ? selectedTab.speaking && "Speaking" : null}
        tab2Name={selectedTab ? selectedTab.reading && "Reading" : null}
        tab3Name={selectedTab ? selectedTab.listening && "Listening" : null}
        tab4Name={selectedTab ? selectedTab.writing && "Writing" : null}
        tab5Name={selectedTab ? selectedTab.grammar && "Grammar" : null}
        tab1={
          selectedTab.speaking ? (
            <OnlineTabItemEdit type={"Speaking"} />
          ) : selectedTab.reading ? (
            <OnlineTabItemEdit type={"Reading"} />
          ) : selectedTab.listening ? (
            <OnlineTabItemEdit type={"Listening"} />
          ) : selectedTab.writing ? (
            <OnlineTabItemEdit type={"Writing"} />
          ) : selectedTab.grammar ? (
            <OnlineTabItemEdit type={"Grammar"} />
          ) : (
            <></>
          )
        }
        tab2={
          selectedTab.reading ? (
            <OnlineTabItemEdit type={"Reading"} />
          ) : selectedTab.listening ? (
            <OnlineTabItemEdit type={"Listening"} />
          ) : selectedTab.writing ? (
            <OnlineTabItemEdit type={"Writing"} />
          ) : selectedTab.grammar ? (
            <OnlineTabItemEdit type={"Grammar"} />
          ) : (
            <></>
          )
        }
        tab3={
          selectedTab.listening ? (
            <OnlineTabItemEdit type={"Listening"} />
          ) : selectedTab.writing ? (
            <OnlineTabItemEdit type={"Writing"} />
          ) : selectedTab.grammar ? (
            <OnlineTabItemEdit type={"Grammar"} />
          ) : (
            <></>
          )
        }
        tab4={
          selectedTab.writing ? (
            <OnlineTabItemEdit type={"Writing"} />
          ) : selectedTab.grammar ? (
            <OnlineTabItemEdit type={"Grammar"} />
          ) : (
            <></>
          )
        }
        tab5={<OnlineTabItemEdit type={"Grammar"} />}
      />
    </Box>
  );
}

export default OnlineTabEdit;
